import 'core-js'
import 'babel-polyfill'
import 'classlist-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  Button,
  Popup,
  Notify,
  Overlay,
  Loading,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Progress,
  Icon,
  Field,
  Picker,
  Dialog,
  NoticeBar,
  Swipe,
  SwipeItem,
  Toast,
  DatetimePicker,
  CellGroup,
  Popover,
  Slider,
  List,
  Cascader,
  Empty,
  Image,
  ActionSheet,
  Form,
  Uploader
} from 'vant'
import '@/assets/scss/index.scss'
import { Bus, MessageType } from 'dygc'
import { loading } from '@/assets/js/loading'
import { overlay } from '@/assets/js/overlay'
import { confirm } from '@/assets/js/confirm'
import scroll from '@/assets/js/scroll'
import { createPopup } from './assets/js/factory'
import CustomNotify from './components/base/CustomNotify'

Vue.config.productionTip = false
Vue.prototype.$wxAppId = process.env.VUE_APP_WX_APP_ID
Vue.use(Field)
Vue.use(List)
Vue.use(Slider)
Vue.use(Picker)
Vue.use(Empty)
Vue.use(Button)
Vue.use(Popover)
Vue.use(Popup)
Vue.use(Cascader)
Vue.use(Notify)
Vue.use(Overlay)
Vue.use(Loading)
Vue.use(RadioGroup)
Vue.use(DatetimePicker)
Vue.use(Radio)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Progress)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(NoticeBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Toast)
Vue.use(CellGroup)
Vue.use(Image)
Vue.use(ActionSheet)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(
  Bus,
  (function () {
    const notifyVm = createPopup(CustomNotify)

    return {
      loading(text = 'loading') {
        let close = loading({
          text
        })
        return {
          close
        }
      },
      message(type, message) {
        const elementMessageType = {
          [MessageType.SUCCESS]: 'success',
          [MessageType.ERROR]: 'danger',
          [MessageType.WARNING]: 'warning'
        }

        if (typeof message === 'string') {
          Notify({
            message,
            type: elementMessageType[type]
          })
        } else {
          notifyVm.showNotify({
            type: elementMessageType[type],
            message: message.message,
            title: message.title
          })
        }
      },
      overlay,
      scroll,
      confirm
    }
  })()
)

// document.body.onselectstart = document.body.ondrag = function () {
//   // 禁止选中文本
//   return false
// }

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
